// extracted by mini-css-extract-plugin
export default {"PortContainer":"virtualPort_PortContainer__B5bE9"};